import { proxy } from "valtio";

interface ContextProps {
  activeView: "worldwide" | "region" | "country";
  activeRegion: number;
  activeCountry: string;
  activeTabWorldwide: number;
  activeTabCountries: number;
  activeTabRegions: number;
  apenhet: any;
  apenhetFullPanelOpen: boolean;
  apenhetContainedPanelOpen: boolean;
  mode: "map" | "data";
  dataExplorations: any;
  isCollapsed: boolean;
  sortTableBy: "country" | "focus" | "prev" | "vuln" | "gov resp";
  sortTableOrder: "asc" | "desc";
  searchQuery: string;
  showMobileLayersOverlay: boolean;
  parsedHash: boolean;
  callCount: any;
  callCountAdd: (key: string) => void;
}

const context: ContextProps = proxy({
  activeView: "worldwide",
  activeTabWorldwide: 0,
  activeTabCountries: 0,
  activeTabRegions: 0,
  activeRegion: null,
  activeCountry: null,
  apenhet: 0,
  apenhetFullPanelOpen: false,
  apenhetContainedPanelOpen: false,
  mode: "map",
  sortTableBy: "country",
  sortTableOrder: "asc",
  sortAlphabetise: "asc",
  searchQuery: "",
  showMobileLayersOverlay: false,
  parsedHash: false,
  callCount: {},
  // Function that appends a key value pair to call count
  // Used to track how many times a function is called
  // Useful for debugging
  callCountAdd(key: string) {
    if (this.callCount[key]) {
      this.callCount[key] += 1;
    } else {
      this.callCount[key] = 1;
    }
  },
  dataExplorations: {
    countries: {
      AUS: {
        buttons: [
          {
            caption: "Apenhet data exploration 1",
            url: "#mode=data:country=aus:dimension=p",
            key: 1
          },
          {
            caption: "Apenhet data exploration 2",
            url: "#mode=data:country=aus:dimension=v",
            key: 2
          },
          {
            caption: "Apenhet data exploration 3",
            url: "#mode=data:country=aus:dimension=r",
            key: 3
          },
          {
            caption: "Apenhet data exploration 4",
            url: "#mode=data:country=aus:dimension=i",
            key: 4
          }
        ]
      }
    }
  },
  isCollapsed: true
});

export default context;
